const galleryItems = [
  {
    name: '天然美肌',
    img: 'https://readdy.ai/api/search-image?query=beauty%20skincare%20supplement%20collagen%20hyaluronic%20acid%20product%20on%20soft%20pink%20white%20background%2C%20rose%20petals%20scattered%2C%20elegant%20feminine%20health%20product%20photography%2C%20bright%20clean%20aesthetic%2C%20natural%20skincare%20wellness%20concept&width=300&height=300&seq=gallery-new-01&orientation=squarish',
  },
  {
    name: '女性私密',
    img: 'https://readdy.ai/api/search-image?query=feminine%20health%20intimate%20care%20supplement%20cranberry%20probiotic%20product%20on%20soft%20pastel%20pink%20background%2C%20delicate%20flower%20petals%2C%20clean%20professional%20womens%20wellness%20product%20photography%2C%20gentle%20feminine%20healthcare%20concept&width=300&height=300&seq=gallery-new-02&orientation=squarish',
  },
  {
    name: '男性魅力',
    img: 'https://readdy.ai/api/search-image?query=mens%20health%20vitality%20supplement%20maca%20zinc%20product%20on%20dark%20sophisticated%20masculine%20background%2C%20modern%20clean%20supplement%20product%20photography%2C%20male%20wellness%20energy%20concept%20professional&width=300&height=300&seq=gallery-new-03&orientation=squarish',
  },
  {
    name: '順暢輕盈',
    img: 'https://readdy.ai/api/search-image?query=digestive%20health%20fiber%20supplement%20probiotic%20product%20with%20fresh%20green%20vegetables%20herbs%20on%20clean%20white%20background%2C%20light%20refreshing%20gut%20health%20product%20photography%2C%20wellness%20cleanse%20concept&width=300&height=300&seq=gallery-new-04&orientation=squarish',
  },
  {
    name: '水潤晶亮',
    img: 'https://readdy.ai/api/search-image?query=eye%20health%20lutein%20supplement%20product%20on%20bright%20crystal%20clear%20blue%20background%2C%20water%20droplets%20dewdrops%20fresh%20hydrating%20concept%2C%20vision%20care%20health%20product%20photography%20clean%20aesthetic&width=300&height=300&seq=gallery-new-05&orientation=squarish',
  },
  {
    name: '健身助力',
    img: 'https://readdy.ai/api/search-image?query=sports%20nutrition%20fitness%20supplement%20protein%20BCAA%20product%20on%20clean%20modern%20dark%20background%2C%20athletic%20health%20performance%20concept%2C%20muscle%20recovery%20supplement%20professional%20photography&width=300&height=300&seq=gallery-new-06&orientation=squarish',
  },
  {
    name: '日常營養',
    img: 'https://readdy.ai/api/search-image?query=daily%20multivitamin%20mineral%20supplement%20capsules%20tablets%20on%20clean%20white%20background%2C%20simple%20essential%20nutrition%20product%20photography%2C%20everyday%20health%20wellness%20concept%20professional&width=300&height=300&seq=gallery-new-07&orientation=squarish',
  },
  {
    name: '兒童成長',
    img: 'https://readdy.ai/api/search-image?query=children%20growth%20supplement%20vitamins%20calcium%20DHA%20product%20on%20bright%20cheerful%20colorful%20background%2C%20kids%20health%20nutrition%20product%20photography%2C%20playful%20yet%20professional%20child%20wellness%20concept&width=300&height=300&seq=gallery-new-08&orientation=squarish',
  },
  {
    name: '好菌加倍',
    img: 'https://readdy.ai/api/search-image?query=probiotic%20supplement%20gut%20health%20lactobacillus%20product%20on%20clean%20fresh%20white%20green%20background%2C%20beneficial%20bacteria%20wellness%20concept%2C%20digestive%20health%20supplement%20professional%20photography&width=300&height=300&seq=gallery-new-09&orientation=squarish',
  },
  {
    name: '毛孩專屬',
    img: 'https://readdy.ai/api/search-image?query=pet%20health%20supplement%20dog%20cat%20nutrition%20product%20with%20paw%20prints%20on%20light%20natural%20background%2C%20animal%20wellness%20care%20product%20photography%2C%20pet%20friendly%20supplement%20clean%20professional%20concept&width=300&height=300&seq=gallery-new-10&orientation=squarish',
  },
];

export default function ProductGallerySection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            熱銷配方
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            豐富產品類型，滿足多元需求
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技代工產品橫跨保健、美容、運動、寵物等多個品類，以下為部分產品示例
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {galleryItems.map((item) => (
            <div key={item.name} className="group cursor-default">
              <div className="rounded-2xl overflow-hidden border border-gray-100 hover:border-green-200 transition-all duration-300 hover:-translate-y-1">
                <div className="w-full h-[200px] sm:h-[220px] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="px-3 py-2.5 text-center bg-[#f7faf7]">
                  <p className="text-[#1a2e1a] font-semibold text-[0.875rem]">{item.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}